import React from 'react'
import { Section, SectionHeader } from '@apexinternal/ui-components'
import { BoxProps } from '@chakra-ui/react'
import { isEmpty } from 'lodash'
import { AccountOwner, OwnerType } from 'types'
import OwnerTable from './OwnerTable'

export interface AccountOwnersTableProps extends BoxProps {
  accountOwners?: AccountOwner[]
}

const AccountOwnersTable = ({
  accountOwners,
  ...rest
}: AccountOwnersTableProps) => {
  if (isEmpty(accountOwners) || !accountOwners) return null
  const primaryOwner = accountOwners.find(
    accountOwner => accountOwner.ownerType === OwnerType.PrimaryOwner
  )
  const jointOwner = accountOwners.find(
    accountOwner => accountOwner.ownerType === OwnerType.JointOwner
  )

  return (
    <Section {...rest}>
      <SectionHeader>Account Owners</SectionHeader>
      {primaryOwner && <OwnerTable accountOwner={primaryOwner} />}
      {jointOwner && <OwnerTable accountOwner={jointOwner} />}
    </Section>
  )
}

export default AccountOwnersTable
